// extracted by mini-css-extract-plugin
export default {"container":"LoginUser_container__1aUu+","loginBox":"LoginUser_loginBox__n8k2m","registerLink":"LoginUser_registerLink__Iy1Cm"};